/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosTable as CosmosTableRoot } from "./CosmosTable";
import { CosmosTableBody } from "./CosmosTableBody";
import { CosmosTableCell } from "./CosmosTableCell";
import { CosmosTableColumn } from "./CosmosTableColumn";
import { CosmosTableHeader } from "./CosmosTableHeader";
import { CosmosTableRow } from "./CosmosTableRow";

import type { CosmosTableProps } from "./CosmosTable";
import type { CosmosTableBodyProps } from "./CosmosTableBody";
import type { CosmosTableCellProps } from "./CosmosTableCell";
import type { CosmosTableColumnProps } from "./CosmosTableColumn";
import type { CosmosTableHeaderProps } from "./CosmosTableHeader";
import type { CosmosTableRowProps } from "./CosmosTableRow";

const CosmosTable: typeof CosmosTableRoot & {
	Body: typeof CosmosTableBody;
	Cell: typeof CosmosTableCell;
	Column: typeof CosmosTableColumn;
	Header: typeof CosmosTableHeader;
	Row: typeof CosmosTableRow;
} = Object.assign(CosmosTableRoot, {
	Body: CosmosTableBody,
	Cell: CosmosTableCell,
	Column: CosmosTableColumn,
	Header: CosmosTableHeader,
	Row: CosmosTableRow,
});

export { CosmosTable, CosmosTableBody, CosmosTableCell, CosmosTableColumn, CosmosTableHeader, CosmosTableRow };

export type {
	CosmosTableProps,
	CosmosTableBodyProps,
	CosmosTableCellProps,
	CosmosTableColumnProps,
	CosmosTableHeaderProps,
	CosmosTableRowProps,
};
